<template>
  <div class="financeEntryDetail">
    <van-form
      label-width="120px"
      :show-error="false"
      :scroll-to-error="false"
      @submit="onSubmit"
    >
      <div class="title" v-if="viewOnly">
        {{ $t.clientFund.financeTitle1 }}
      </div>
      <span v-else>
        <div class="title" v-if="isEdit">
          {{ $t.clientFund.financeTitle2 }}
        </div>
        <div class="title" v-else>{{ $t.clientFund.financeTitle3 }}</div>
      </span>

      <van-field
        v-model="form.PaymentTypeStr"
        :label="$t.clientFund.fundClass"
        @click="pickerShow('showFundClassPicker')"
        :placeholder="$t.meta.select"
        clickable
        readonly
        required
        :rules="formRule"
      />

      <van-field
        v-model="form.AccountIdStr"
        :label="$t.clientFund.bankAccount"
        @click="pickerShow('showAccountPicker')"
        :placeholder="$t.meta.select"
        clickable
        readonly
        required
        :rules="formRule"
      />

      <van-field
        v-model="form.RemitterName"
        :label="$t.clientFund.remitterName"
        :placeholder="viewOnly ? '' : $t.meta.input"
        :disabled="viewOnly ? true : false"
        required
        :rules="formRule"
      />

      <div class="custom-date">
        <div class="date-btn1">
          <div class="date-require">*</div>
          {{ $t.clientFund.receiveDate }}
        </div>
        <div class="date-btn2" @click="showTimeDate">
          <span v-if="form.FillInOrReceiveDate" class="value">{{
            form.FillInOrReceiveDate
          }}</span>
          <span v-else class="placeholder">{{ $t.meta.select }}</span>
        </div>
      </div>

      <van-field
        v-model="form.RemittanceLocation"
        :label="$t.clientFund.remittanceLocation"
        :placeholder="viewOnly ? '' : $t.meta.input"
        :disabled="viewOnly ? true : false"
      />

      <van-field
        v-model="form.RemittanceCurrencySn"
        :label="$t.clientFund.remittanceCurrency"
        @click="pickerShow('showCurrencyPicker', 1)"
        :placeholder="$t.meta.select"
        clickable
        readonly
        required
        :rules="formRule"
      />

      <van-field
        v-model="form.RemittanceAmount"
        :label="$t.clientFund.remittanceAmount"
        :placeholder="viewOnly ? '' : $t.meta.input"
        :disabled="viewOnly ? true : false"
        oninput="if(value === ''){value = null} if (isNaN(value)) {value = null}"
        required
        :rules="formRule"
      />

      <van-field
        v-model="form.BankChargesCurrencySn"
        :label="$t.clientFund.bankChargesCurrency"
        @click="pickerShow('showCurrencyPicker', 2)"
        :placeholder="$t.meta.select"
        clickable
        readonly
      />

      <van-field
        v-model="form.BankCharges"
        :label="$t.clientFund.bankCharges"
        :placeholder="viewOnly ? '' : $t.meta.input"
        :disabled="viewOnly ? true : false"
        oninput="if(value === ''){value = null} if (isNaN(value)) {value = null}"
      />

      <van-field
        v-model="form.ReceivedCurrencySn"
        :label="$t.clientFund.receivedCurrency"
        @click="pickerShow('showCurrencyPicker', 3)"
        :placeholder="$t.meta.select"
        clickable
        readonly
      />

      <van-field
        v-model="form.ReceivedAmount"
        :label="$t.clientFund.receivedAmount"
        :placeholder="viewOnly ? '' : $t.meta.input"
        :disabled="viewOnly ? true : false"
        oninput="if(value === ''){value = null} if (isNaN(value)) {value = null}"
      />

      <van-field
        v-model="form.Remark"
        :label="$t.clientFund.remark"
        :placeholder="viewOnly ? '' : $t.meta.input"
        :disabled="viewOnly ? true : false"
        type="textarea"
        rows="3"
      />

      <van-field
        v-model="form.PaymentTradeNumber"
        :label="$t.clientFund.paymentTradeNumber"
        label-class="number-label"
        readonly
        type="textarea"
        rows="3"
        v-if="form.PaymentTradeNumber"
      >
        <template #button>
          <van-button
            size="small"
            type="info"
            native-type="button"
            @click="onCopy(form.PaymentTradeNumber)"
            >{{ $t.meta.copy }}</van-button
          >
        </template>
      </van-field>

      <div class="multi-table" v-if="form.FileList">
        <van-field name="stepper" :label="$t.clientFund.fileList">
          <template #input>
            <van-stepper
              :min="0"
              :value="form.FileList.length"
              @minus="handleDel"
              @plus="handleAdd"
              :disable-input="true"
              :disabled="viewOnly ? true : false"
            />
          </template>
        </van-field>
        <div v-for="(item, index) in form.FileList" :key="index">
          <div class="multi-table-header" v-if="!viewOnly">
            <div class="multi-table-title"></div>
            <div class="multi-table-btn" @click="handleDelByIndex(index)">
              <van-icon name="close" />
            </div>
          </div>
          <van-field :label="$t.clientFund.file + (index + 1)">
            <template #input>
              <van-button
                @click="imagePreview(imgUrlFilter(item.FileAddress))"
                type="primary"
                size="small"
                style="vertical-align: top; margin: 10px 30px 10px 0px"
                native-type="button"
                v-if="item.FileAddress"
                >{{ $t.meta.view }}</van-button
              >
              <van-uploader :after-read="afterRead1" @click-upload="uploaderClick(index)">
                <van-image
                  :src="item.FileAddress && imgUrlFilter(item.FileAddress)"
                  width="50"
                  height="50"
                  fit="contain"
                  style="vertical-align: top"
                  v-if="item.FileAddress"
                ></van-image>
                <van-button
                  type="info"
                  size="small"
                  style="vertical-align: top; margin: 10px 30px 10px 0px"
                  native-type="button"
                  v-else
                  >{{ $t.meta.upload }}</van-button
                >
              </van-uploader>
            </template>
          </van-field>
        </div>
      </div>

      <div style="margin: 16px" v-if="!viewOnly">
        <van-button round block type="info" native-type="submit">{{
          $t.meta.submit
        }}</van-button>
      </div>
    </van-form>

    <van-popup v-model="showFundClassPicker" round position="bottom">
      <van-picker
        :title="$t.clientFund.fundClass"
        show-toolbar
        :columns="fundClassOptions"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="fundClassConfirm($event)"
        @cancel="showFundClassPicker = false"
      />
    </van-popup>

    <van-popup v-model="showAccountPicker" round position="bottom">
      <van-picker
        :title="$t.clientFund.bankAccount"
        show-toolbar
        :columns="accountInfoList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="accountConfirm($event)"
        @cancel="showAccountPicker = false"
      />
    </van-popup>

    <van-popup v-model="showCurrencyPicker" round position="bottom">
      <van-picker
        :title="$t.meta.currency"
        show-toolbar
        :columns="currencyList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="currencyConfirm($event)"
        @cancel="showCurrencyPicker = false"
      />
    </van-popup>

    <van-popup v-model="showTimePicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t.clientFund.receiveDate"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event)"
        @cancel="showTimePicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>
  </div>
</template>
<script>
import Vue from "vue";
import {
  Form,
  Field,
  Button,
  Icon,
  Image,
  Radio,
  RadioGroup,
  Checkbox,
  CheckboxGroup,
  Popup,
  DatetimePicker,
  Uploader,
  Stepper,
  Picker,
} from "vant";

Vue.use(Form)
  .use(Field)
  .use(Button)
  .use(Icon)
  .use(Image)
  .use(Radio)
  .use(RadioGroup)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Popup)
  .use(DatetimePicker)
  .use(Uploader)
  .use(Stepper)
  .use(Picker);

export default {
  name: "financeEntryDetail",
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      isEdit: false,
      viewOnly: false,
      form: {
        CEId: null,
        PaymentTypeStr: "",
        PaymentType: 1,
        AccountIdStr: "",
        AccountId: null,
        RemitterName: "",
        FillInOrReceiveDate: "",
        RemittanceLocation: "",
        RemittanceAmount: null,
        RemittanceCurrencySn: "",
        RemittanceCurrency: null,
        BankCharges: null,
        BankChargesCurrencySn: "",
        BankChargesCurrency: null,
        ReceivedAmount: null,
        ReceivedCurrencySn: "",
        ReceivedCurrency: null,
        Remark: "",
        PaymentTradeNumber: "",
        FileList: [],
      },
      formRule: [
        {
          required: true,
          message: this.$t.meta.require,
        },
      ],
      //选项
      fundClassOptions: [],
      accountInfoList: [],
      currencyList: [],
      //picker
      showFundClassPicker: false,
      showAccountPicker: false,
      showCurrencyPicker: false,
      itemType: 0,
      //日期
      selectDate: new Date(),
      currentDate: "",
      showTimePicker: false,
      //文件
      filesIndex: 0,
    };
  },
  created() {
    const { CEId } = this.$route.query;
    this.initOptions();
    if (CEId) {
      this.isEdit = true;
      this.form.CEId = CEId;
      this.getOptions().then((success) => {
        if (success) this.getCustomerCapitalEntryByCEId();
      });
    } else {
      this.isEdit = false;
      this.getOptions();
    }
  },
  methods: {
    initOptions() {
      this.fundClassOptions = [
        {
          text: this.$t.clientFund.paymentType1,
          value: 1,
        },
        {
          text: this.$t.clientFund.paymentType2,
          value: 2,
        },
      ];
    },
    getOptions() {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        Promise.all([this.getCurrencyList(), this.getCollectionAccountInfoList()])
          .then((success) => {
            if (success) {
              resolve(true);
            }
            this.$commonMethod.hideLoading();
          })
          .catch(() => {
            this.$commonMethod.hideLoading();
          });
      });
    },
    getCurrencyList() {
      return new Promise((resolve) => {
        this.$api.financialManagement
          .getSystemAvailableCurrencyList()
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text: item.CurrencySn,
                value: item.SCId,
              };
              result.push(data);
            });
            this.currencyList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    getCollectionAccountInfoList() {
      return new Promise((resolve) => {
        this.$api.financialManagement
          .getCollectionAccountInfoList({
            CompanyId: this.CompanyId,
            IsEnable: 1,
            PageIndex: 0,
            PageSize: 1000,
          })
          .then((res) => {
            var result = [];
            res.data.Data.forEach((item) => {
              let data = {
                text: item.AccountNickName,
                value: item.AccountId,
              };
              result.push(data);
            });
            this.accountInfoList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    showTimeDate() {
      if (this.viewOnly) {
        return;
      }
      var start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = start;
      this.showTimePicker = true;
    },
    formatter(type, val) {
      if (type === "year") {
        return val + this.$t.meta.year;
      }
      if (type === "month") {
        return val + this.$t.meta.month;
      }
      if (type === "day") {
        return val + this.$t.meta.day;
      }
      return val;
    },
    dateChange(date) {
      var formatDate = (val) => {
        var value = new Date(val);
        var time = value.toLocaleDateString();
        let [year, month, date] = time.split("/");
        if (month < 10) {
          month = "0" + month;
        }
        if (date < 10) {
          date = "0" + date;
        }
        return year + "-" + month + "-" + date;
      };
      this.form.FillInOrReceiveDate = formatDate(date);
      this.showTimePicker = false;
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    imagePreview(images) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.picturePreview, {
        pictureList: [images],
        startPosition: 0,
      });
    },
    applyData(data) {
      //款项归类
      this.form.PaymentType = data.PaymentType;
      var payment = this.fundClassOptions.find((c) => c.value == this.form.PaymentType);
      if (payment) {
        this.form.PaymentTypeStr = payment.text;
      }
      //银行账户
      this.form.AccountId = data.AccountId.toString();
      var account = this.accountInfoList.find((c) => c.value == this.form.AccountId);
      if (account) {
        this.form.AccountIdStr = account.text;
      }
      //货币
      this.form.RemittanceCurrency = data.RemittanceCurrency.toString();
      var currency1 = this.currencyList.find(
        (c) => c.value == this.form.RemittanceCurrency
      );
      if (currency1) {
        this.form.RemittanceCurrencySn = currency1.text;
      }
      this.form.BankChargesCurrency = data.BankChargesCurrency.toString();
      var currency2 = this.currencyList.find(
        (c) => c.value == this.form.BankChargesCurrency
      );
      if (currency2) {
        this.form.BankChargesCurrencySn = currency2.text;
      }
      this.form.ReceivedCurrency = data.ReceivedCurrency.toString();
      var currency3 = this.currencyList.find(
        (c) => c.value == this.form.ReceivedCurrency
      );
      if (currency3) {
        this.form.ReceivedCurrencySn = currency3.text;
      }
      this.form.RemitterName = data.RemitterName;
      this.form.FillInOrReceiveDate = data.FillInOrReceiveDate;
      this.form.RemittanceLocation = data.RemittanceLocation;
      this.form.RemittanceAmount = data.RemittanceAmount;
      this.form.BankCharges = data.BankCharges;
      this.form.ReceivedAmount = data.ReceivedAmount;
      this.form.Remark = data.Remark;
      this.form.PaymentTradeNumber = data.PaymentTradeNumber;
      this.form.FileList = data.FileList;
    },
    getCustomerCapitalEntryByCEId() {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        this.$api.financialManagement
          .getCustomerCapitalEntryByCEId({
            CEId: this.form.CEId,
          })
          .then((res) => {
            if (res.data.EntryState == 1) {
              this.viewOnly = true;
            } else {
              this.viewOnly = false;
            }
            this.applyData(res.data);
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    pickerShow(pickerName, type) {
      if (this.viewOnly) {
        return;
      }
      this.initOptions();
      this[pickerName] = true;
      this.itemType = type;
    },
    currencyConfirm(e) {
      if (this.itemType == 1) {
        this.form.RemittanceCurrencySn = e.text;
        this.form.RemittanceCurrency = e.value;
      }
      if (this.itemType == 2) {
        this.form.BankChargesCurrencySn = e.text;
        this.form.BankChargesCurrency = e.value;
      }
      if (this.itemType == 3) {
        this.form.ReceivedCurrencySn = e.text;
        this.form.ReceivedCurrency = e.value;
      }
      this.showCurrencyPicker = false;
    },
    fundClassConfirm(e) {
      this.form.PaymentTypeStr = e.text;
      this.form.PaymentType = e.value;
      this.showFundClassPicker = false;
    },
    accountConfirm(e) {
      this.form.AccountIdStr = e.text;
      this.form.AccountId = e.value;
      this.showAccountPicker = false;
    },
    onSubmit() {
      var param = {};
      param = this.form;
      this.$commonMethod.showLoading();
      var request = null;
      if (this.isEdit) {
        request = this.$api.financialManagement.editCustomerCapitalFinanceEntry(param);
      } else {
        request = this.$api.financialManagement.addCustomerCapitalFinanceEntry(param);
      }
      request
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    handleDelByIndex(index) {
      if (this.form.FileList.length > 0) {
        this.form.FileList.splice(index, 1);
      }
    },
    handleDel() {
      if (this.form.FileList.length > 0) {
        this.form.FileList.pop();
      }
    },
    handleAdd() {
      this.form.FileList.push({
        FileAddress: "",
      });
    },
    uploaderClick(index) {
      this.filesIndex = index;
    },
    afterRead1(file) {
      this.$commonMethod.showLoading();
      var formData = new FormData();
      formData.append("file", file.file);
      this.$api.system
        .uploadImgFile(formData)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.meta.uploadSuccess,
            type: "success",
          });
          this.form.FileList[this.filesIndex].FileAddress = res.data;
          this.$commonMethod.hideLoading();
        })
        .catch(() => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: this.$t.meta.uploadFail,
          });
        });
    },
    onCopy(text) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.clickCopy, {
        text: text,
        alertText: this.$t.meta.copySuccess,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.financeEntryDetail {
  ::v-deep .number-label {
    line-height: 33px;
  }
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
  ::v-deep .van-radio__icon--disabled.van-radio__icon--checked {
    i {
      color: #1890ff;
      font-weight: bold;
    }
  }
  ::v-deep .van-radio__label--disabled.van-radio__label {
    color: #646566 !important;
    -webkit-text-fill-color: #646566 !important;
  }
  ::v-deep .van-checkbox__icon--disabled.van-checkbox__icon--checked {
    i {
      color: #1890ff;
      font-weight: bold;
    }
  }
  ::v-deep .van-checkbox__label--disabled.van-checkbox__label {
    color: #646566 !important;
    -webkit-text-fill-color: #646566 !important;
  }
  ::v-deep .van-field--disabled {
    .van-field__label,
    .van-field__control {
      color: #646566 !important;
      -webkit-text-fill-color: #646566 !important;
    }
  }
  .financeEntryDetail-radio {
    padding: 20px;
    border-bottom: 1px solid #ebedf0;
    .radio-label {
      color: #646566;
      margin-bottom: 20px;
      font-size: 14px;
    }
    .van-radio {
      margin-right: 20px;
      margin-bottom: 10px;
      font-size: 14px;
    }
  }
  .financeEntryDetail-checkbox {
    padding: 20px;
    border-bottom: 1px solid #ebedf0;
    .checkbox-label {
      color: #646566;
      margin-bottom: 20px;
      font-size: 14px;
    }
    .van-checkbox {
      margin-right: 20px;
      margin-bottom: 10px;
      font-size: 14px;
    }
  }
  .custom-date {
    padding: 12px 16px;
    border-bottom: 1px solid #ebedf0;
    .date-btn1 {
      width: 120px;
      display: inline-block;
      margin-right: 12px;
      font-size: 14px;
      color: #646566;
      .date-require {
        color: red;
        position: absolute;
        left: 8px;
      }
    }
    .date-btn2 {
      width: 50%;
      display: inline-block;
      font-size: 14px;
      .value {
        color: #323233;
      }
      .placeholder {
        color: #c3c3c3;
      }
    }
  }
  .multi-table {
    .multi-table-header {
      padding: 10px 15px;
      .multi-table-title {
        font-size: 14px;
        color: #999;
        width: 70%;
        display: inline-block;
        vertical-align: middle;
      }
      .multi-table-btn {
        font-size: 20px;
        color: #000;
        width: 30%;
        display: inline-block;
        text-align: right;
        vertical-align: middle;
      }
    }
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    border-top: 1px solid #f6f6f6;
    .tool-button {
      align-items: center;
    }
  }
}
</style>
